<template>
  <div>
    <view-table
        ref="viewTable"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="accessories/getPackScanList"
        :table-select="false"
        @reset="resetHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="物料号/条码">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入物料号/条码" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>

    <el-dialog
        title="包装图片"
        :close-on-click-modal="true"
        :visible.sync="dialogVisible"
        width="1000px">
      <div class="image-container">
        <div class="image-with-watermark">
          <el-image :src="originImgUrl" fit="contain"/>
          <div class="watermark time-watermark">{{timeStr}}</div>
          <div class="watermark barcode-watermark">{{barcode}}</div>
        </div>
      </div>
      <template #footer>
        <el-button @click="dialogVisible = false">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";

  export default {
    name: "PackScanQuery",
    components: { ViewTable },
    data() {
      return {
        filter: {
          materialNo: "",
        },
        dialogVisible: false,
        originImgUrl: "",
        watermarkSrc: "",
        timeStr: "",
        barcode: "",
        columnsProperty: [
          {
            key: "itemType",
            label: "文件类型",
            width: 120,
            align: "center",
            render: (h, params) => {
              return h("span", params.row.itemType === 13 ? "包装扫描" : "非包装扫描");
            },
          },
          {
            key: "filePath",
            width: 140,
            align: "center",
            render: (h, params) => {
              if (params.row.filePath) {
                const previewTime = params.row.createTime;
                const serialNo = params.row.serialNo || "";
                const imgUrl = params.row.filePath.replaceAll("httpss", "https");
                return h(
                  "el-image",
                  {
                    attrs: {
                      src: imgUrl,
                      alt: "包装图片",
                      fit: "cover",
                    },
                    style: {
                      width: "50px",
                      height: "50px",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.showImage(imgUrl, previewTime, serialNo);
                      },
                    },
                  }
                );
              } else {
                return h("span", "--");
              }
            },
          },
        ],
      };
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      showImage(originImgUrl, time, barcode) {
        this.dialogVisible = true;
        this.originImgUrl = originImgUrl;
        this.timeStr = time || "";
        this.barcode = barcode || "";
      },
    },
  };
</script>

<style lang="scss" scoped>
  .image-container {
    text-align: center;
    margin: 0 auto;
  }

  .image-with-watermark {
    position: relative;
    display: inline-block;
    ::v-deep .el-image__inner {
      width: 900px;
    }
  }

  .watermark {
    position: absolute;
    color: #ffffff;
    font-size: 14px;
    font-family: Microsoft YaHei;
    background: rgba(0, 0, 0, 0.5);
    padding: 5px 10px;
    border-radius: 4px;
    z-index: 10;
  }

  .time-watermark {
    top: 10px;
    left: 10px;
  }

  .barcode-watermark {
    top: 10px;
    left: 220px;
  }

  .el-image {
    max-width: 100%;
    max-height: 800px;
  }
</style>
